"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasLayerId = exports.formatUrl = void 0;
var parse_1 = require("./parse");
function formatUrl(baseUrl, params, _a) {
    if (params === void 0) { params = {}; }
    var _b = _a === void 0 ? {
        debug: false,
        sortParams: true,
    } : _a, _c = _b.debug, debug = _c === void 0 ? false : _c, _d = _b.sortParams, sortParams = _d === void 0 ? true : _d;
    var url = new URL(baseUrl);
    var keys = Object.keys(params);
    if (sortParams) {
        if (debug) {
            // eslint-disable-next-line no-console
            console.log("[format-url] sorting keys");
        }
        // eslint-disable-next-line fp/no-mutating-methods
        keys.sort();
    }
    keys.forEach(function (k) {
        var value = params[k];
        // don't want ?param=undefined in url
        if (value === undefined) {
            return;
        }
        url.searchParams.append(k, value.toString());
    });
    return url.toString();
}
exports.formatUrl = formatUrl;
function hasLayerId(ids, target, _a) {
    var _b = _a === void 0 ? {
        strict: false,
    } : _a, _c = _b.strict, strict = _c === void 0 ? false : _c;
    return !!ids.find(function (id) {
        var _a = (0, parse_1.parseName)(id), full = _a.full, short = _a.short, namespace = _a.namespace;
        if (strict) {
            return full === target;
        }
        var parsedTarget = (0, parse_1.parseName)(target);
        return (short === parsedTarget.short &&
            (parsedTarget.namespace ? namespace === parsedTarget.namespace : true));
    });
}
exports.hasLayerId = hasLayerId;
